module.exports = __webpack_public_path__ + "static/media/BollinoSconto50.943ac8dd.png";